import { AdminLoginType } from "common/types";
import * as yup from "yup";

export const LoginValidationSchema = yup.object<AdminLoginType>({
  userName: yup.string().required("وارد کردن نام کاربری الزامیست"),
  password: yup.string().required("وارد کردن رمز عبور الزامیست"),
});
